// src/config.js
const config = {
  BASE_URL: 'https://backend.tracko.online',
  
};

export default config;
